import { Navigate, useLocation, matchPath } from "react-router-dom";
import { selectAuth, selectMyProfile } from "../store/auth/authSlice";
import { useSelector } from "react-redux";
import routes from "routes/routes";
import { ReactNode } from "react";
import { RouteEl } from "types";

const CheckAccessRoute = ({
	children,
}: {
  children: ReactNode;
}): JSX.Element => {
	const auth = useSelector(selectAuth);
	const myProfile = useSelector(selectMyProfile);
	const { permissions = [] } = myProfile;
	const { pathname } = useLocation();
	let permissionValid = false;

	if (!auth) {
		return <Navigate to="/login" />;
	}

	let route: RouteEl | null = null;
	routes.forEach(el => {
		if (matchPath({ path: el.path }, pathname)) {
			route = el;
		}
		if (el.children) {
			el.children.forEach(item => {
				if(item.children && item.children.length > 0) {
					item.children.forEach((childItem) => {
						if (matchPath({ path: childItem.path }, pathname)) {
							route = childItem;
						} else if( childItem.children && childItem.children.length) {
							childItem.children.forEach((child) => {
								if (matchPath({ path: child.path }, pathname)) {
									route = child;
								} 
							})
						}
					});
				} else {
					if (matchPath({ path: item.path }, pathname)) {
						route = item;
					}
				}
			});
		}
	});
	


	if (!route) {
		return <Navigate to="/not-found" />;
	}

	const { permissions: routePerms = [] } = route;

	if (routePerms.length === 0) {
		permissionValid = true;
	} else {
		permissionValid = permissions.find((el: string) =>
			routePerms.find((item: string) => item === el),
		)
			? true
			: false;
	}

	if (!permissionValid) {
		return <Navigate to="/access-denied" />;
	}

	return <>{children}</>;
};

export default CheckAccessRoute;
